import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-markers/dist/videojs.markers.css";
import "videojs-markers";
import { Stage, Layer, Rect } from "react-konva";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { changeVideoPostStatus, createUpdateFeedback, getCoachFeedback, fetchCachedFeedback } from "../../../redux/network/coachAPI";
import { addStandaloneFeedback } from "../../../redux/reducers/standaloneSlice";
import { updateStandAloneVideoStatusFunction } from "../../../redux/network/standAloneApi";
// import styles from "./CreateFeedback.module.scss"; // SCSS Removed
import { error_GetFetchVideoContent, isStarted_GetFetchVideoContent, success_GetFetchVideoContent, } from "../../../redux/reducers/videoSlice";

import { getFetchGamePostFileThumbnail, getVideos } from "../../../redux/network/videoApi";
import { POST_LIST_POST } from "../../../config/endpoints";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrash,
  faCheck,
  faXmark,
  faBolt,
  faChevronLeft,

  faChevronRight,
  faDownload,
  faPaperPlane,
  faVideo
} from "@fortawesome/free-solid-svg-icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Menu, MenuItem, Fade, Tooltip } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { FaMicrophone, FaTrash as FaTrashIcon } from "react-icons/fa";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import FeedbackList from "../componnets/FeedbackList";
import AnnotationStage from "../componnets/Annotations";
import VideoPlayer from "../componnets/VideojsPlayer";
import jsPDF from "jspdf";
import { useLocation } from 'react-router-dom';
import GameVideoDetails from '../../GamePost/GameVideoDetails/GameVideoDetails';
import CoachClosingFeedback from '../componnets/CoachClosingFeedback';
import axios from 'axios';
import {
  GENERATE_AI_FEEDBACKS,
  GET_AI_FEEDBACK_STATE
} from '../../../config/endpoints';
import TagHelper from '../../../helpers/PostHelpers/TagHelper';
import { useRallyData } from '../../../hooks/useRallyData';
import useMatchMeta from '../../../hooks/useMatchMeta';
import { extractVideoFileName, extractMatchIdFromFilename } from '../../../utils/rallyDataUtils';
import { FlashOnRounded } from "@mui/icons-material";
import { GET_INDIVIDUAL_REPORT } from '../../../config/endpoints';

import { NEW_FEEDBACKS_NOTIFICATION, VIDEO_SEARCH_API_LIMIT } from "../../../constant";
import FetchLatestAiFeedbackPopUp from "./FechLatestAiFeedbackPopUp/FetchLatestAiFeedbackPopUp";
import { appendVideosToList, updateVideoList } from "../../../redux/reducers/videoSlice";
import { usePagination } from "../../../hooks/usePagination";


const CreateFeedback = () => {
  const { postId: videoId } = useParams();
  const env = process.env.REACT_APP_ENV;
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [comment, setComment] = useState("");
  const [newAnnotation, setNewAnnotation] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [drawing, setDrawing] = useState(false);
  const navigate = useNavigate();
  const videoContent = useSelector((state) => state.video.videoContent);
  const dispatch = useDispatch();

  // Safety reset: Clear any stuck loading state from previous session on mount
  useEffect(() => {
    if (videoContent.isStartedvideoContent) {
      console.warn('⚠️ Resetting stuck video loading state from previous session');
      dispatch(error_GetFetchVideoContent('Reset on mount'));
    }
  }, []); // Empty dependency array - only run once on mount

  // Rally data hook for SmartInsights integration
  const { fetchRallyData, loading: rallyLoading, error: rallyError } = useRallyData();
  const { fetchMatchMeta, loading: metaLoading, error: metaError } = useMatchMeta();
  const [loadingSmartInsights, setLoadingSmartInsights] = useState(false);

  const [videoDimensions, setVideoDimensions] = useState({
    width: 0,
    height: 0,
  });

  // Keep videoDimensions in sync with the actual rendered video size
  useEffect(() => {
    if (!videoRef.current) return;

    let resizeTimeout;
    const updateDimensions = () => {
      // Clear any pending timeout
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }

      // Debounce the dimension update
      resizeTimeout = setTimeout(() => {
        if (!videoRef.current) return;

        const newWidth = videoRef.current.clientWidth;
        const newHeight = videoRef.current.clientHeight;

        // Only update if dimensions actually changed (avoid unnecessary re-renders)
        setVideoDimensions((prev) => {
          if (Math.abs(prev.width - newWidth) > 1 || Math.abs(prev.height - newHeight) > 1) {
            return { width: newWidth, height: newHeight };
          }
          return prev;
        });
      }, 100); // 100ms debounce
    };

    // Initial set
    updateDimensions();

    // Responsive observer
    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(videoRef.current);

    return () => {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeObserver.disconnect();
    };
  }, [videoRef]);

  const standAloneFeedbacks = useSelector((state) => state.standAlone.feedbacks.feedbackData);
  const [annotations, setAnnotations] = useState([]);
  // Video navigation states - using Redux pagination system only
  const [videoList, setVideoList] = useState([]);
  const [totalVideos, setTotalVideos] = useState(0);
  const [isNavigating, setIsNavigating] = useState(false);
  const AI_FEEDBACK_CREATED = "created";
  const AI_FEEDBACK_REVIEW_REQUESTED = "review_requested";
  const AI_FEEDBACK_REVIEWED = "reviewed";
  // Use Redux pagination instead of localStorage
  const {
    currentPage,
    totalPages,
    totalRecords,
    searchTerm,
    sortOption,
    goToPage,
    goToNextPage,
    goToPreviousPage
  } = usePagination('pending');

  // Calculate current video position based on Redux pagination
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  // Add global position tracking
  const [currentGlobalPosition, setCurrentGlobalPosition] = useState(1); // Track current position in state

  // Remove all localStorage dependencies
  const [positionUpdateTrigger, setPositionUpdateTrigger] = useState(0);

  const [onceTimeAnnotaions, setOnceTimeAnnotaions] = useState([]);
  const [audioComment, setAudioComment] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const maxRecordingDuration =
    parseInt(process.env.REACT_APP_MAX_RECORDING_DURATION) || 4; // Default to 4 seconds if not set
  const ffmpeg = new FFmpeg();
  const maxAudioFeedbacks = parseInt(process.env.REACT_APP_MAX_AUDIO_FEEDBACKS) || 2; // Default to 2 if not set
  const [mediaStream, setMediaStream] = useState(null); // Add this new state

  const [expandedCommentId, setExpandedCommentId] = useState(null); // Track the expanded comment ID
  const controlBarHeight = 25;
  const userId = localStorage.getItem("BQS__ID");
  const jwtToken = localStorage.getItem("BQS_TOKEN");
  const firstname = localStorage.getItem("firstname");
  const lastname = localStorage.getItem("lastname");
  const reviewPostId = localStorage.getItem('reviewPostId');
  const reviewPost = JSON.parse(localStorage.getItem(`${reviewPostId}_reviewPost`));
  const videoUrl = localStorage.getItem("videoLinkInObjectStore");
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showVideoLoader, setShowVideoLoader] = useState(true);
  // Use Redux data instead of localStorage
  const [data, setData] = useState(null);

  const [frameRate, setFrameRate] = useState(30);
  const [videoThumbnails, setVideoThumbnails] = useState({});
  const [thumbnailLoading, setThumbnailLoading] = useState({});
  const thumbnailUrl = videoThumbnails[videoId] || "https://www.fisu.net/app/uploads/2023/09/badminton.jpg";

  const [videoKey, setVideoKey] = useState(Date.now()); // Force re-render video element
  const [isLoading, setIsLoading] = useState(false); // State for the loader
  const [isDownloading, setIsDownloading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (isMatchVideo) {
      setAnchorEl(event.currentTarget);
    } else {
      handleDownload('summary');
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = (type) => {
    downloadPDF(type);
    handleClose();
  };

  const konvaRef = useRef(null);
  const location = useLocation();
  const rawVideoTags = location.state?.videoTags;
  const videoTagList = useMemo(() => {
    const locationTags = Array.isArray(rawVideoTags) ? rawVideoTags : [];
    const storedTags = Array.isArray(reviewPost?.tags) ? reviewPost.tags : [];
    const reduxTags = Array.isArray(data?.tags) ? data.tags : [];
    const merged = TagHelper.mergeTagLists(
      TagHelper.mergeTagLists(locationTags, storedTags),
      reduxTags
    );
    if (!reviewPostId) {
      return merged;
    }
    const keyPath = reviewPost?.game?.[0]?.path || data?.game?.[0]?.path;
    const persisted = TagHelper.getPersistedTags(reviewPostId, keyPath);
    return TagHelper.mergeTagLists(merged, persisted);
  }, [rawVideoTags, reviewPost, data, reviewPostId]);

  const isMatchVideo = useMemo(() => {
    return Array.isArray(videoTagList) && videoTagList.some(tag => {
      const name = typeof tag === 'string' ? tag : (tag?.tagName || tag?.name);
      return name?.toLowerCase() === "match video";
    });
  }, [videoTagList]);

  const path = location.pathname;
  const url = localStorage.getItem("videoLinkInObjectStore") || location.state?.videoUrl || null; // Get from localStorage first, then fallback to navigation state
  const { postId } = useParams();
  const [displayDialogBoxForNewAIFeedbacks, setDisplayDialogBoxForNewAIFeedbacks] = useState(false);
  const intervalRef = useRef(null);
  const [contentRect, setContentRect] = useState({ width: 0, height: 0 });


  // Add ref to track if polling is already active
  const isPollingActiveRef = useRef(false);

  // Add ref to track if AI feedback has been fetched
  const aiFeedbackFetchedRef = useRef(false);


  // Get video data from Redux
  const { data: videoData, isStarted: isVideoDataLoading, totalNumberOfRecords } = useSelector(state => state.video.video);

  // Use totalNumberOfRecords directly from Redux state - same as Pending.js
  const actualTotalCount = totalRecords || totalNumberOfRecords || 0

  // Calculate total pages based on total count divided by limit
  let totalNumberOfPages = Math.ceil(actualTotalCount / VIDEO_SEARCH_API_LIMIT);

  // Ensure totalNumberOfPages is at least 1
  if (totalNumberOfPages < 1) {
    totalNumberOfPages = 1;
  }

  const dataFormatter = (dateString) => {
    const inputDate = new Date(dateString);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = inputDate.getDate();
    const monthIndex = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();

    return `${day} ${monthNames[monthIndex]} ${year} at ${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  };

  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [annotationToDelete, setAnnotationToDelete] = useState(null);
  const [isSaving, setIsSaving] = useState(false); // Add this new state
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [pollAiFeedbackState, setPollAiFeedbackState] = useState(false);
  const [showMatchVideoModal, setShowMatchVideoModal] = useState(false);
  const [matchRallyId, setMatchRallyId] = useState(null);
  const [showNoInsightsModal, setShowNoInsightsModal] = useState(false);
  const [matchVideoReadyToPublish, setMatchVideoReadyToPublish] = useState(false);
  const [isRallyDataNotFound, setIsRallyDataNotFound] = useState(false);
  const [showPublishConfirmation, setShowPublishConfirmation] = useState(false);
  const GENERATE_AI_FEEDBACK_BUTTON_STATE = ["Get AI Feedback", "Getting AI Feedback", "Got AI Feedback"];
  // Consistently manage AI feedback state from localStorage, location state, or default
  const [aiFeedbackState, setAiFeedbackState] = useState(() => {
    return localStorage.getItem(`latestAiFeedbackState_${postId}`) || location.state?.aiFeedbackState || "created";
  });
  const [isGeneratingFeedback, setIsGeneratingFeedback] = useState(aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED);
  const generationStartTimeRef = useRef(parseInt(localStorage.getItem(`generationStartTime_${postId}`) || "0"));

  // Calculate button disabled state based on current video's AI feedback state
  const isGetAiFeedbackButtonDisabled = aiFeedbackState === AI_FEEDBACK_REVIEWED ||
    (!localStorage.getItem("exclusiveFeaturesEnabled")?.includes('Generate AI Feedback') && aiFeedbackState === AI_FEEDBACK_CREATED);

  // Minimal fix: On page reload, if AI feedback is already reviewed, hydrate annotations immediately
  useEffect(() => {
    const hydrateIfReviewed = async () => {
      try {
        if (aiFeedbackState === AI_FEEDBACK_REVIEWED && !aiFeedbackFetchedRef.current) {
          const loaded = await loadExistingAiFeedbackData(0);
          if (loaded !== false) {
            aiFeedbackFetchedRef.current = true;
          }
        }
      } catch (_) { }
    };
    hydrateIfReviewed();
    // Only depends on state and videoId so it runs on reload/navigation
  }, [aiFeedbackState, videoId]);

  // Eagerly check for rally data on Match Videos to handle "Insights Pending" state
  useEffect(() => {
    const checkRallyAvailability = async () => {
      const currentUrl = url || data?.game?.[0]?.path;
      if (!videoId || !currentUrl) return;

      const isMatchVideoInEffect = videoTagList.some(tag => tag?.tagName === "Match Video");
      if (!isMatchVideoInEffect) {
        setIsRallyDataNotFound(false);
        return;
      }

      try {
        const videoFileName = extractVideoFileName(currentUrl);
        const matchId = extractMatchIdFromFilename(videoFileName);
        const result = await fetchRallyData(matchId, videoId);
        if (!result) {
          setIsRallyDataNotFound(true);
        } else {
          setIsRallyDataNotFound(false);
        }
      } catch (err) {
        // If 404 or other error, treat as Insights Pending for Match Videos
        setIsRallyDataNotFound(true);
      }
    };

    checkRallyAvailability();
  }, [videoId, url, data?.game?.[0]?.path, videoTagList.length]);


  const POLLING_INTERVAL_IN_SECS = 10000;
  const STOP_POLLING_AFTER_SECS = 18000;
  const RELOADED_PAGE_STR = "reload";
  const [timerInterval, setTimerInterval] = useState();
  const extractTitle = (url) => {
    if (!url) return "Unknown Title";
    return url.split("/").pop().split(".")[0]; // Extract filename without extension
  };


  // Get video title from data or URL
  const getVideoTitle = () => {
    if (data?.game?.[0]?.path) {
      return extractTitle(data.game[0].path);
    } else if (url) {
      return extractTitle(url);
    }
    return "Unknown Title";
  };

  const videoTitle = getVideoTitle();
  // Remove localStorage storage - use component state instead

  // SmartInsights navigation helpers
  // Detect SmartInsights Playground key for this video (e.g., 'video1', 'video3', 'video11')
  const detectPlaygroundKey = useCallback(() => {
    try {
      const pools = [videoTitle, data?.title, data?.name, data?.videoName, data?.originalFileName, data?.game?.[0]?.path, url]
        .filter(Boolean)
        .map(v => String(v).toLowerCase());
      for (const s of pools) {
        const m = s.match(/video(\d{1,2})/);
        if (m) return `video${m[1]}`;
      }
    } catch { }
    return null;
  }, [videoTitle, data, url]);

  // Navigate to SmartInsights Playground for this specific video
  const handleViewInSmartInsights = useCallback(async () => {
    try {
      setLoadingSmartInsights(true);

      // Extract video filename from URL
      const videoFileName = extractVideoFileName(url || data?.game?.[0]?.path);

      // Get the match ID by removing file extension from filename
      // Backend expects: "Prisha_0024_Near" not "Prisha_0024_Near.mp4"
      const matchId = extractMatchIdFromFilename(videoFileName);



      let rallyData = null;
      let matchMeta = null;

      try {
        // Use cached result or fetch if needed
        rallyData = isRallyDataNotFound ? null : await fetchRallyData(matchId, postId);

      } catch (rallyErr) {
        console.error('[CreateFeedback] Failed to fetch rally data:', rallyErr);
      }

      // If no rally data, show the "not available" modal and stop
      if (!rallyData || isRallyDataNotFound) {
        setIsRallyDataNotFound(true);
        setShowNoInsightsModal(true);
        setLoadingSmartInsights(false);
        return;
      }

      try {
        // Fetch match metadata/statistics using video filename
        matchMeta = await fetchMatchMeta(videoFileName);

      } catch (metaErr) {
        console.error('[CreateFeedback] Failed to fetch match metadata:', metaErr);
        // Continue anyway - will use rally data for statistics if available
      }

      // Get actual thumbnail URL - check if already loaded, otherwise fetch it
      let actualThumbnailUrl = videoThumbnails[videoId] || thumbnailUrl;


      // Only fetch if we have a placeholder or no thumbnail
      if (!actualThumbnailUrl || actualThumbnailUrl === "https://www.fisu.net/app/uploads/2023/09/badminton.jpg") {
        try {
          // Try to fetch the actual thumbnail
          const tnPath = data?.tn?.[0]?.path;
          if (tnPath) {
            const jwtToken = localStorage.getItem('BQS_TOKEN');
            const fetchedThumbnail = await getFetchGamePostFileThumbnail(jwtToken, videoId, tnPath);
            if (fetchedThumbnail) {
              actualThumbnailUrl = fetchedThumbnail;

            }
          } else {
            console.warn('[CreateFeedback] No thumbnail path found in data.tn[0].path');
          }
        } catch (thumbnailErr) {
          console.warn('[CreateFeedback] Could not fetch thumbnail:', thumbnailErr);
        }
      }

      // Final fallback to ensure we always have a valid URL
      if (!actualThumbnailUrl) {
        actualThumbnailUrl = thumbnailUrl || "https://www.fisu.net/app/uploads/2023/09/badminton.jpg";
      }



      // Store video data for Playground with rally data and match metadata
      const videoDataToStore = {
        postId: postId || data?._id || videoId,
        videoUrl: url || data?.url || data?.game?.[0]?.path,
        videoTitle: getVideoTitle(),
        thumbnailUrl: actualThumbnailUrl, // Use fetched thumbnail instead of placeholder
        rallyData,
        matchMeta // Add match metadata for statistics
      };

      // Store in localStorage for persistence (can be retrieved anytime)
      // Use a unique key based on match ID for easy retrieval
      const storageKey = `RALLY_DATA_${matchId}`;
      localStorage.setItem(storageKey, JSON.stringify(rallyData));

      // Also store in sessionStorage for direct load flow
      sessionStorage.setItem('PG_DIRECT_LOAD', '1');
      sessionStorage.setItem('PG_DIRECT_VIDEO_DATA', JSON.stringify(videoDataToStore));



      // Legacy support: also try to detect playground key for fallback
      const key = detectPlaygroundKey();
      if (key) {
        try {
          const raw = localStorage.getItem('PLAYGROUND_POST_ID_MAP');
          const map = raw ? JSON.parse(raw) : {};
          map[key] = postId || data?._id || videoId;
          localStorage.setItem('PLAYGROUND_POST_ID_MAP', JSON.stringify(map));
          localStorage.setItem('PLAYGROUND_SELECTED_VIDEO', key);
        } catch { }
      }

      // Navigate to Playground
      navigate('/SmartInsights');
    } catch (err) {
      console.error('[CreateFeedback] Failed to navigate to SmartInsights Playground:', err);
      toast.error('Failed to open SmartInsights. Please try again.');
    } finally {
      setLoadingSmartInsights(false);
    }
  }, [fetchRallyData, detectPlaygroundKey, postId, data, videoId, url, videoTitle, navigate]);


  // Single video loading state management
  useEffect(() => {
    // Show loader initially when video changes
    if (!videoLoaded) {
      setShowVideoLoader(true);
      setLoading(true);
    }

    // Hide loader when video is fully loaded and ready
    if (videoLoaded && !loading) {

      const timer = setTimeout(() => {
        setShowVideoLoader(false);
      }, 300); // Smooth transition delay

      return () => clearTimeout(timer);
    }
  }, [videoLoaded, loading]);

  // Initialize loader on component mount
  useEffect(() => {
    setShowVideoLoader(true);
    setLoading(true);
  }, []);

  // Safety mechanism: Hide loader if video content is available but loading is stuck
  useEffect(() => {
    if (videoContent?.videoContentUrl && loading) {
      const safetyTimer = setTimeout(() => {

        setLoading(false);
        setShowVideoLoader(false);
      }, 3000); // Hide loader after 3 seconds as safety

      return () => clearTimeout(safetyTimer);
    }
  }, [videoContent, loading]);

  // Track which thumbnails we've already preloaded
  const preloadedThumbnailsRef = useRef(new Set());

  // Preload thumbnails for adjacent videos for faster navigation
  useEffect(() => {
    const preloadAdjacentThumbnails = async () => {
      if (!videoData?.length || !jwtToken || env === "standalone") return;

      const currentVideos = env === "standalone"
        ? videoData.filter(video => video.state === "review_requested")
        : videoData;

      const currentIndex = currentVideos.findIndex(video => video._id === videoId);
      if (currentIndex === -1) return;

      // Preload next and previous video thumbnails
      const videosToPreload = [];

      // Previous video
      if (currentIndex > 0) {
        const prevVideo = currentVideos[currentIndex - 1];
        if (prevVideo?.game?.[0]?.tnPath) {
          videosToPreload.push({
            id: prevVideo._id,
            tnPath: prevVideo.game[0].tnPath
          });
        }
      }

      // Next video
      if (currentIndex < currentVideos.length - 1) {
        const nextVideo = currentVideos[currentIndex + 1];
        if (nextVideo?.game?.[0]?.tnPath) {
          videosToPreload.push({
            id: nextVideo._id,
            tnPath: nextVideo.game[0].tnPath
          });
        }
      }

      // Preload thumbnails in background - only if not already preloaded
      videosToPreload.forEach(async ({ id, tnPath }) => {
        const preloadKey = `${id}:${tnPath}`;
        // Check if we've already attempted to preload this thumbnail
        if (!preloadedThumbnailsRef.current.has(preloadKey)) {
          preloadedThumbnailsRef.current.add(preloadKey);
          try {
            const thumbnailUrl = await getFetchGamePostFileThumbnail(jwtToken, id, tnPath);
            setVideoThumbnails(prev => ({
              ...prev,
              [id]: thumbnailUrl
            }));
          } catch (error) {
            console.error('[CreateFeedback] Failed to preload thumbnail:', error);
          }
        }
      });
    };

    preloadAdjacentThumbnails();
  }, [videoData, videoId, jwtToken, env]); // Removed videoThumbnails from dependencies

  // ========================================
  // FIXED VIDEO NAVIGATION SYSTEM
  // ========================================

  // Initialize navigation state from Redux pagination data
  const initializeNavigationState = useCallback(() => {
    if (!videoId || !videoData?.length) return;

    // Find the video in current Redux data
    const currentVideos = env === "standalone"
      ? videoData.filter(video => video.state === "review_requested")
      : videoData;

    const currentIndex = currentVideos.findIndex(video => video._id === videoId);

    if (currentIndex >= 0) {
      // Set the current video index
      setCurrentVideoIndex(currentIndex);

      // Set the current video data from Redux
      setData(currentVideos[currentIndex]);

      // Calculate and set the global position
      const globalPosition = ((currentPage - 1) * VIDEO_SEARCH_API_LIMIT) + currentIndex + 1;
      setCurrentGlobalPosition(globalPosition);
    } else {
      setCurrentVideoIndex(0);
      if (currentVideos.length > 0) {
        setData(currentVideos[0]);

        // Calculate and set the global position for default case
        const globalPosition = ((currentPage - 1) * VIDEO_SEARCH_API_LIMIT) + 1;
        setCurrentGlobalPosition(globalPosition);
      }
    }
  }, [videoId, videoData, env, currentPage, totalRecords]);

  // Calculate global position - using actual video position in total dataset
  const calculateGlobalPosition = useCallback(() => {
    const storedTotal = Number(localStorage.getItem('lastTotalInSearch_pending')) || 0;
    const totalCount = totalRecords || actualTotalCount || (Array.isArray(videoData) ? videoData.length : 0) || storedTotal || 0;

    // Always calculate position based on current page and index
    const calculatedPosition = ((currentPage - 1) * VIDEO_SEARCH_API_LIMIT) + currentVideoIndex + 1;

    // Use calculated position, but ensure it doesn't exceed total count
    const actualPosition = Math.min(calculatedPosition, totalCount);

    // Additional validation: if we're on a page that shouldn't exist, adjust
    const maxPage = Math.ceil(totalCount / VIDEO_SEARCH_API_LIMIT);
    if (currentPage > maxPage) {
      // If we're beyond the last page, show the last video
      return { currentPosition: totalCount, totalInSearch: totalCount };
    }

    return { currentPosition: actualPosition, totalInSearch: totalCount };
  }, [currentPage, currentVideoIndex, totalRecords, actualTotalCount, videoData]);

  // Minimal persistence: store last known total to use across reloads
  useEffect(() => {
    const currentTotals = totalRecords || actualTotalCount || (Array.isArray(videoData) ? videoData.length : 0) || 0;
    if (currentTotals > 0) {
      localStorage.setItem('lastTotalInSearch_pending', String(currentTotals));
    }
  }, [totalRecords, actualTotalCount, videoData]);

  // Function to load next page of videos and add to Redux
  const loadNextPageOfVideos = useCallback(async () => {
    if (!jwtToken || !userId || env === "standalone") return null;

    try {
      const nextPage = currentPage + 1;
      const nextPageSkip = nextPage - 1; // API receives skip = page - 1

      const apiUrl = new URL(POST_LIST_POST);
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken} `,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "condition": {
            "state": ["review_requested"],
            "searchTerm": "",
            "poster": userId
          },
          "sort": {
            "coachManualFeedback": 1, // Empty feedback first (1 = ascending, empty strings come first)
            "updatedAt": -1,          // Then by newest date for videos with feedback
            "createdAt": -1           // Also consider creation date for better sorting
          },
          "skip": nextPageSkip,  // Use page - 1 for skip
          "limit": VIDEO_SEARCH_API_LIMIT
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.code === 200 && data.data && data.data.searchResults) {
          const newVideos = data.data.searchResults;

          return newVideos;
        } else { }
      } else { }
    } catch (error) { }

    return null;
  }, [jwtToken, userId, env, currentPage]);

  // Function to load previous page of videos and add to Redux
  const loadPreviousPageOfVideos = useCallback(async () => {
    if (!jwtToken || !userId || env === "standalone") return null;

    try {
      const previousPage = currentPage - 1;

      if (previousPage < 1) {
        return null;
      }

      const previousPageSkip = previousPage - 1; // API receives skip = page - 1

      const apiUrl = new URL(POST_LIST_POST);
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken} `,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "condition": {
            "state": ["review_requested"],
            "searchTerm": "",
            "poster": userId
          },
          "sort": {
            "coachManualFeedback": 1, // Empty feedback first (1 = ascending, empty strings come first)
            "updatedAt": -1,          // Then by newest date for videos with feedback
            "createdAt": -1           // Also consider creation date for better sorting
          },
          "skip": previousPageSkip,  // Use page - 1 for skip
          "limit": VIDEO_SEARCH_API_LIMIT
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.code === 200 && data.data && data.data.searchResults) {
          const newVideos = data.data.searchResults;

          return newVideos;
        } else { }
      } else { }
    } catch (error) { }

    return null;
  }, [jwtToken, userId, env, currentPage]);

  // Function to navigate to a specific video
  const navigateToSpecificVideo = useCallback(async (nextVideo) => {
    // Clear current state IMMEDIATELY to prevent showing previous video's data
    setAnnotations([]);
    setComment("");
    setAudioComment(null);
    setNewAnnotation(null);
    setCurrentTime(0);
    setDrawing(false);
    setIsPaused(false);
    setVideoLoaded(false);
    setLoading(true);

    // Update data state
    setData(nextVideo);
    setVideoKey(Date.now());

    // Clean up video player
    try {
      if (playerRef?.current) {
        if (typeof playerRef.current.pause === 'function') {
          playerRef.current.pause();
        }
        if (typeof playerRef.current.dispose === 'function') {
          playerRef.current.dispose();
        }
        playerRef.current = null;
      }
    } catch (error) { }

    // Store video data in localStorage for the new video
    const videoLinkInObjectStore = nextVideo.game[0].path;
    const aiFeedbackState = nextVideo?.aiFeedbackState || "created";

    // Update localStorage for the new video IMMEDIATELY
    localStorage.setItem("videoLinkInObjectStore", videoLinkInObjectStore);
    localStorage.setItem("reviewPostId", nextVideo._id);
    localStorage.setItem(`${nextVideo._id} _reviewPost`, JSON.stringify(nextVideo));

    // Update localStorage for AI feedback state of the new video
    localStorage.setItem(`latestAiFeedbackState_${nextVideo._id}`, aiFeedbackState);

    // Update component state for the new video
    setAiFeedbackState(aiFeedbackState);
    setIsGeneratingFeedback(aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED);

    // Reset AI feedback fetched flag for new video
    aiFeedbackFetchedRef.current = false;

    // Load existing AI feedback data if the video has been reviewed
    if (aiFeedbackState === AI_FEEDBACK_REVIEWED) {
      // We'll load the data after navigation completes with longer delay
      setTimeout(() => {
        loadExistingAiFeedbackData(0, nextVideo._id); // Pass the specific video ID
      }, 500); // Increased delay to ensure navigation is complete
    }

    // Navigate with all data in state
    navigate(`/coach_flow/pending-video/feedback/${nextVideo._id}`, {
      state: {
        videoTags: nextVideo.tags,
        aiFeedbackState: aiFeedbackState,
        videoUrl: videoLinkInObjectStore,
        userData: env !== "standalone" ? {
          firstName: nextVideo?.poster?.profileData?.name?.firstName || "",
          lastName: nextVideo?.poster?.profileData?.name?.lastName || ""
        } : null
      },
      replace: true
    });
  }, [navigate, env]);

  // Simplified navigation to next/previous video
  const navigateToVideo = useCallback(async (direction) => {
    if (isNavigating) {
      return;
    }

    // Get current videos from Redux
    const currentVideos = env === "standalone"
      ? videoData.filter(video => video.state === "review_requested")
      : videoData;

    let nextVideo = null;
    let newPage = currentPage;
    let newIndex = currentVideoIndex;
    let needsApiCall = false; // Track if we need to call API
    let newVideos = null; // Store new videos from API

    if (direction === 'next') {
      // Check if we can go to next video in current page
      if (currentVideoIndex < (currentVideos?.length || 0) - 1) {
        // Same page navigation - NO API call needed
        newIndex = currentVideoIndex + 1;
        nextVideo = currentVideos[newIndex];
      } else {
        needsApiCall = true;
        try {
          newVideos = await loadNextPageOfVideos();
          if (newVideos && newVideos.length > 0) {
            newPage = currentPage + 1;
            newIndex = 0;
            nextVideo = newVideos[0];
          }
        } catch (error) { }
      }
    } else if (direction === 'previous') {
      // Check if we can go to previous video in current page
      if (currentVideoIndex > 0) {
        // Same page navigation - NO API call needed
        newIndex = currentVideoIndex - 1;
        nextVideo = currentVideos[newIndex];
      } else {
        needsApiCall = true;
        try {
          newVideos = await loadPreviousPageOfVideos();
          if (newVideos && newVideos.length > 0) {
            newPage = currentPage - 1;
            newIndex = newVideos.length - 1;
            nextVideo = newVideos[newIndex];
          }
        } catch (error) { }
      }
    }

    if (!nextVideo) {
      return;
    }

    setIsNavigating(true);

    try {
      // Update Redux pagination state and video list if page changed
      if (newPage !== currentPage) {
        // Update Redux pagination
        goToPage(newPage);

        // Update Redux video list with new videos from API
        if (newVideos && newVideos.length > 0) {
          dispatch(updateVideoList({ videos: newVideos }));
        }
      } else { }

      setCurrentVideoIndex(newIndex);

      // Calculate the correct global position
      const globalPosition = ((newPage - 1) * VIDEO_SEARCH_API_LIMIT) + newIndex + 1;

      // Update global position state
      setCurrentGlobalPosition(globalPosition);

      // Navigate to the video
      await navigateToSpecificVideo(nextVideo);
    } catch (error) {
      toast.error("Error navigating to video");
    } finally {
      setIsNavigating(false);
    }
  }, [videoData, videoId, env, isNavigating, currentPage, currentVideoIndex, totalRecords, goToPage, jwtToken, userId, dispatch, navigateToSpecificVideo, loadNextPageOfVideos, loadPreviousPageOfVideos]);

  const handleNextVideo = () => {
    navigateToVideo('next');
  };

  const handlePreviousVideo = () => {
    navigateToVideo('previous');
  };

  // Function to fetch videos for a specific page/range - ONLY when user navigates
  const fetchVideosForRange = useCallback(async (skip, limit = VIDEO_SEARCH_API_LIMIT) => {
    if (!jwtToken || !userId || env === "standalone") return null;

    try {
      const pageNumber = Math.floor(skip / VIDEO_SEARCH_API_LIMIT) + 1;

      const apiUrl = new URL(POST_LIST_POST);
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwtToken} `,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "condition": {
            "state": ["review_requested"],
            "searchTerm": "",
            "poster": userId
          },
          "sort": {
            "coachManualFeedback": 1, // Empty feedback first (1 = ascending, empty strings come first)
            "updatedAt": -1,          // Then by newest date for videos with feedback
            "createdAt": -1           // Also consider creation date for better sorting
          },
          "skip": pageNumber - 1, // Use skip = page - 1 formula
          "limit": limit
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.code === 200 && data.data && data.data.searchResults) {
          return data.data;
        } else { }
      } else { }
    } catch (error) { }

    return null;
  }, [jwtToken, userId, env]);

  // ========================================
  // OPTIMIZED REDUX-BASED DATA MANAGEMENT
  // ========================================
  // 
  // Key optimizations:
  // 1. Only fetch video count when not available in Redux
  // 2. Only fetch videos when not available in Redux  
  // 3. Use Redux data for navigation instead of localStorage
  // 4. Proper pagination with 9 videos per page
  // 5. Efficient thumbnail preloading
  // 6. Removed complex localStorage management
  // ========================================

  useEffect(() => {

    const entries = window.performance.getEntriesByType("navigation");
    if (entries.length > 0 && entries[0].type === RELOADED_PAGE_STR) {
      getAiFeedbackState();
    }


    return (() => {

      clearInterval(intervalRef.current);
    });
  }, []);


  // Initialize navigation state when component mounts or video data changes
  useEffect(() => {
    if (videoId && videoData?.length > 0) {
      initializeNavigationState();
    }
  }, [videoId, videoData, initializeNavigationState]);

  // Sync Redux pagination state with current data
  useEffect(() => {
    if (totalNumberOfRecords && totalNumberOfRecords !== totalRecords) { }
  }, [totalNumberOfRecords, totalRecords]);

  // REMOVED: No automatic loading of missing videos on mount
  // Only load videos when user explicitly navigates
  useEffect(() => { }, [videoData, actualTotalCount]);

  // Cleanup effect for component unmounting
  useEffect(() => {
    return () => {
      // Clean up video player on component unmount
      try {
        if (playerRef.current) {
          playerRef.current.dispose();
          playerRef.current = null;
        }
      } catch (error) { }

      // Clear any remaining intervals
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // Use current video data from Redux
    const currentVideos = env === "standalone"
      ? videoData.filter(video => video.state === "review_requested")
      : videoData;

    if (currentVideos.length > 0) {
      setTotalVideos(actualTotalCount);
    } else { }
  }, [videoData, env, actualTotalCount]);

  // Load video data on mount if not available in Redux (for page reloads)
  useEffect(() => {
    const loadVideoDataOnMount = async () => {
      if (!jwtToken || !userId || env === "standalone") return;

      // Check if we need to load data (either no data or different page)
      const needsDataLoad = !videoData || videoData.length === 0;

      if (needsDataLoad) {
        try {
          const apiUrl = new URL(POST_LIST_POST);
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${jwtToken} `,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "condition": {
                "state": ["review_requested"],
                "searchTerm": "",
                "poster": userId
              },
              "sort": {
                "coachManualFeedback": 1, // Empty feedback first (1 = ascending, empty strings come first)
                "updatedAt": -1,          // Then by newest date for videos with feedback
                "createdAt": -1           // Also consider creation date for better sorting
              },
              "skip": currentPage - 1,
              "limit": VIDEO_SEARCH_API_LIMIT
            })
          });

          if (response.ok) {
            const data = await response.json();
            if (data.code === 200 && data.data && data.data.searchResults) {
              const videos = data.data.searchResults;

              // Update pagination totals so counters reflect all pages (not just current page)
              if (typeof data.data.totalNumberOfRecords === 'number') {
                dispatch({
                  type: 'pagination/updatePaginationFromResponse',
                  payload: {
                    totalRecords: data.data.totalNumberOfRecords,
                    currentPage,
                    searchTerm,
                    sortOption,
                    component: 'pending'
                  }
                });
              }

              // Update Redux with the loaded data
              dispatch(updateVideoList({ videos }));

              // Find the current video in the loaded data
              const currentVideo = videos.find(video => video._id === videoId);
              if (currentVideo) {
                setData(currentVideo);

                // Set the correct video index
                const videoIndex = videos.findIndex(video => video._id === videoId);
                setCurrentVideoIndex(videoIndex >= 0 ? videoIndex : 0);
              } else { }
            }
          }
        } catch (error) { }
      } else { }
    };

    loadVideoDataOnMount();
  }, [jwtToken, userId, env, videoData, currentPage, videoId, dispatch]);

  // Update video list when video data changes - use Redux data efficiently
  useEffect(() => {
    if (videoData) {
      const filteredVideos = env === "standalone"
        ? videoData.filter(video => video.state === "review_requested")
        : videoData;

      setVideoList(filteredVideos);
      setTotalVideos(actualTotalCount);
    }
  }, [videoData, videoId, env, actualTotalCount]);

  // Update data state when videoId changes (for thumbnail loading and page reloads)
  useEffect(() => {
    if (videoId) {
      // Try to get video data from Redux first
      const currentVideos = env === "standalone"
        ? videoData?.filter(video => video.state === "review_requested")
        : videoData;

      const videoFromRedux = currentVideos?.find(video => video._id === videoId);

      if (videoFromRedux) {
        setData(videoFromRedux);

        // Set the correct video index
        const videoIndex = currentVideos.findIndex(video => video._id === videoId);
        setCurrentVideoIndex(videoIndex >= 0 ? videoIndex : 0);

        // Initialize navigation state immediately
        initializeNavigationState();
      } else {
        const reviewPostId = localStorage.getItem('reviewPostId');
        const reviewPost = JSON.parse(localStorage.getItem(`${reviewPostId} _reviewPost`));

        if (reviewPost && reviewPost._id === videoId) {
          setData(reviewPost);

          // Initialize navigation state immediately
          initializeNavigationState();
        } else { }
      }
    }
  }, [videoId, videoData, env, initializeNavigationState]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.target.tagName === 'TEXTAREA' || event.target.tagName === 'INPUT') {
        return; // Don't handle navigation when typing
      }

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          if (calculateGlobalPosition().currentPosition > 1) {
            handlePreviousVideo();
          }
          break;
        case 'ArrowRight':
          event.preventDefault();
          if (calculateGlobalPosition().currentPosition < calculateGlobalPosition().totalInSearch) {
            handleNextVideo();
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [calculateGlobalPosition, handlePreviousVideo, handleNextVideo]);



  // Initialize navigation state when videoData changes
  useEffect(() => {
    if (videoData && videoData.length > 0) {
      initializeNavigationState();
    } else { }
  }, [videoData, initializeNavigationState]);

  // Track which thumbnails we've already attempted to load for current video
  const thumbnailLoadedRef = useRef(null);

  // Enhanced thumbnail loading with page reload support
  useEffect(() => {
    const loadThumbnail = async () => {
      if (!data?._id || !jwtToken || env === "standalone") return;

      const reviewPostId = data._id;
      const tnPath = data.game?.[0]?.tnPath;

      // Skip if we've already loaded this thumbnail
      if (thumbnailLoadedRef.current === reviewPostId) {
        return;
      }

      // Mark as loading
      thumbnailLoadedRef.current = reviewPostId;

      // Strategy 2: Set loading state and fallback immediately
      setThumbnailLoading(prev => ({ ...prev, [reviewPostId]: true }));
      setVideoThumbnails((prev) => ({
        ...prev,
        [reviewPostId]: "https://www.fisu.net/app/uploads/2023/09/badminton.jpg",
      }));


      // Strategy 3: Fetch actual thumbnail with timeout
      if (tnPath) {
        try {

          // Create a promise with timeout
          const thumbnailPromise = getFetchGamePostFileThumbnail(
            jwtToken,
            reviewPostId,
            tnPath
          );

          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Thumbnail fetch timeout')), 5000) // Increased timeout for page reloads
          );

          const thumbnailUrl = await Promise.race([thumbnailPromise, timeoutPromise]);


          setVideoThumbnails((prev) => ({
            ...prev,
            [reviewPostId]: thumbnailUrl,
          }));


          setVideoKey(`video - ${new Date().getTime()} `);
        } catch (error) {
          console.error('[CreateFeedback] Thumbnail load error:', error);
        } finally {
          setThumbnailLoading(prev => ({ ...prev, [reviewPostId]: false }));
        }
      } else {
        setThumbnailLoading(prev => ({ ...prev, [reviewPostId]: false }));
      }
    };

    // Load thumbnail immediately when component mounts or data changes
    loadThumbnail();
  }, [data?._id, jwtToken, env]); // Removed videoThumbnails from dependencies

  // Enhanced video content loading with page reload support
  useEffect(() => {
    // Optimization: Skip blob fetching and use direct URL for streaming
    const videoUrl = data?.game?.[0]?.path || url;

    if (videoId && videoUrl) {
      console.log('🎬 Using direct video URL for streaming:', videoUrl);

      // Dispatch success immediately with the direct URL
      // This bypasses the memory-intensive blob fetch
      dispatch(success_GetFetchVideoContent(videoUrl));

      setVideoLoaded(true);
      setLoading(false);
      setShowVideoLoader(false);
    } else if (!videoId) {
      // If no video ID, stop loading
      setLoading(false);
    }
  }, [videoId, dispatch, data, url]);

  const handlePopUpClose = () => {
    setDisplayDialogBoxForNewAIFeedbacks(false);
  };



  const clearAllFeedbacks = async () => {

    if (
      jwtToken && videoId && videoId.length === 0
    )
      return;

    try {
      const response = await createUpdateFeedback(jwtToken, [], videoId);
      if (response && response?.code === 200 &&
        response?.data?.aiFeedbackState &&
        response?.data?.feedbacks) {
        setAiFeedbackState(response.data.aiFeedbackState);
        setAnnotations(response.data.feedbacks);
        setDrawing(false);
        setIsPaused(false);

        // Store current position before reload
        const currentPosition = calculateGlobalPosition().currentPosition;

        // Store position data in localStorage
        localStorage.setItem("pendingReloadPosition", JSON.stringify({
          position: currentPosition,
          page: currentPage,
          videoIndex: currentVideoIndex,
          videoId: videoId,
          timestamp: Date.now()
        }));

        window.location.reload();

        // Remove toast message
        // toast.success("Feedbacks cleared successfully");
      }

    }
    catch (error) {
      toast?.error("Unable to clear feedbacks");
    }
  };

  const getCachedFeedbacks = async () => {

    if (
      jwtToken && videoId && videoId.length === 0
    )
      return;

    try {
      const response = await fetchCachedFeedback(jwtToken, videoId);

      if (response && response?.code === 200 &&
        response?.data?.aiFeedbackState &&
        response?.data?.feedbacks) {
        handlePopUpClose();
        setAiFeedbackState(response.data.aiFeedbackState);
        setAnnotations(response.data.feedbacks);
        setDrawing(false);
        setIsPaused(false);

        // Store current position before reload
        const currentPosition = calculateGlobalPosition().currentPosition;

        // Store position data in localStorage
        localStorage.setItem("pendingReloadPosition", JSON.stringify({
          position: currentPosition,
          page: currentPage,
          videoIndex: currentVideoIndex,
          videoId: videoId,
          timestamp: Date.now()
        }));

        window.location.reload();

        // Remove toast message
        // toast.success("Cached feedbacks loaded successfully");
      }

    }
    catch (error) {
      toast?.error("Unable to get cached feedbacks");
    }
  };

  const handleSaveAnnotation = async () => {

    if (!comment.trim() && !audioComment) {
      toast.error("Please provide a comment or record an audio comment.");
      return;
    }
    setIsLoading(true);
    try {
      setEditingCommentId(null);
      setEditedCommentText("");

      // Use contentRect for annotation saving
      const videoWidth = contentRect.width;
      const videoHeight = contentRect.height;

      if (!videoWidth || !videoHeight) {
        toast.error("Video content area size is invalid.");
        setIsLoading(false);
        return;
      }

      const relativeCoordinates = {
        x1: newAnnotation?.x / videoWidth,
        y1: newAnnotation?.y / videoHeight,
        x2: (newAnnotation?.x + newAnnotation?.width) / videoWidth,
        y2: (newAnnotation?.y + newAnnotation?.height) / videoHeight,
      };

      // Safe currentTime retrieval with null checks
      let currentTimes = 0;
      try {
        if (playerRef?.current && typeof playerRef.current.currentTime === 'function') {
          currentTimes = playerRef.current.currentTime();

        } else { }
      } catch (error) {

        currentTimes = 0;
      }

      // Create array to hold comments
      const commentsToAdd = [];

      // Add text comment if present
      if (comment.trim()) {
        commentsToAdd.push({
          _id: uuidv4(), // Generate unique ID for each comment
          body: comment.trim(),
          metaData: {
            dateTime: new Date().toISOString(),
            userId,
            userName: "coach16",
          },
          type: "text",
        });
      }
      if (audioComment) {
        commentsToAdd.push({
          _id: uuidv4(), // Generate unique ID for each comment
          body: audioComment,
          metaData: {
            dateTime: new Date().toISOString(),
            userId,
            userName: "coach16",
          },
          type: "audio",
        });
      }
      // Create separate annotation entries for each comment
      const newAnnotations = commentsToAdd.map((commentData, index) => ({
        _id: annotations.length + index + 1,
        timeRange: { startTime: currentTimes, endTime: currentTimes },
        markerDetails: { coordinates: relativeCoordinates },
        comments: [commentData],
      }));

      const updatedAnnotations = [...annotations, ...newAnnotations];
      setAnnotations(updatedAnnotations);
      saveFeedback(updatedAnnotations);
      toast.success("Feedback submitted successfully!");

      // Add markers to the player with null checks
      try {
        if (playerRef?.current && playerRef.current.markers) {
          const markers = updatedAnnotations.map((annotation) => ({
            time: annotation.timeRange.startTime,
            text: annotation?.comments?.[0]?.body.startsWith("data:audio")
              ? "Audio"
              : annotation?.comments?.[0]?.body || "Annotation", // Default text if no comment exists
          }));
          playerRef.current.markers.add(markers); // Add updated markers
        }

      } catch (error) { }

    } catch (error) {
      toast.error("Failed to save annotation. Please try again.");
    } finally {
      setComment("");
      setAudioComment(null);
      setNewAnnotation(null);
      setIsLoading(false);
    }
  };

  const saveFeedback = async (updatedAnnotations) => {
    if (!updatedAnnotations) {
      toast.error("Please add Makers and commnets");
      return;
    }
    setIsSaving(true); // Show loader when starting to save
    try {
      const feedbackData = updatedAnnotations.map((annotation) => ({
        ...(env === "standalone" ? { _id: annotation._id } : {}),
        timeRange: annotation.timeRange,
        markerDetails: {
          coordinates: {
            x1: annotation.markerDetails.coordinates.x1 || 0,
            y1: annotation.markerDetails.coordinates.y1 || 0,
            x2: annotation.markerDetails.coordinates.x2 || 0,
            y2: annotation.markerDetails.coordinates.y2 || 0,
          },
          videoContainer: annotation.markerDetails.videoContainer,
          size: annotation.markerDetails.size,
        },
        comments: annotation.comments.map((comment) => ({
          metaData: comment.metaData,
          body: comment.body,
        })),
      }));

      if (env === "standalone") {
        const standAloneFeedback = {
          _id: videoId,
          feedback: feedbackData,
        };
        dispatch(addStandaloneFeedback(standAloneFeedback));
        dispatch(updateStandAloneVideoStatusFunction(videoId));
        return null;
      }

      await createUpdateFeedback(jwtToken, feedbackData, videoId);
    } catch (error) {
      toast.error(error.message || "Error while submitting feedback");
    } finally {
      setIsSaving(false); // Hide loader when done
    }
  };

  const backNavigation = () => {
    // Clear stored position when going back to ensure fresh calculation
    localStorage.removeItem("currentVideoGlobalPosition");
    localStorage.removeItem("currentPageContext");
    localStorage.removeItem("currentPage");
    localStorage.removeItem("currentVideoIndex");
    localStorage.removeItem("previousPosition");

    navigate("/coach_flow/pending-video");
  };









  const submitData = async () => {
    // 1. Identify manual coach annotations:
    // - Must have at least one comment with a valid userId (coach's ID)
    // - Must not be marked as AI in any way (type, flag, or comment metadata)
    const manualCoachAnnotations = (annotations || []).filter(a => {
      const type = String(a.type || "").toLowerCase();
      const isAi = a.isAI || a.isAi || type.includes("ai") || type === "ai_feedback";
      if (isAi) return false;
      
      return a.comments?.some(c => {
        const meta = c.metaData || {};
        const userName = String(meta.userName || "").toLowerCase();
        // Exclude system/ai usernames even if they have IDs
        if (userName.includes("ai") || userName.includes("system")) return false;
        return !!meta.userId;
      });
    });
    
    // 2. Check for coach closing feedback text safely
    const hasClosingFeedback = !!(
      data?.coachManualFeedback && 
      typeof data.coachManualFeedback === 'string' && 
      data.coachManualFeedback.trim().length > 0
    );
    
    // If absolutely no manual coach input is found, show the confirmation
    if (manualCoachAnnotations.length === 0 && !hasClosingFeedback) {
      setShowPublishConfirmation(true);
      return;
    }

    await performSubmit();
  };

  const handleConfirmPublish = async () => {
    setShowPublishConfirmation(false);
    await performSubmit();
  };

  const performSubmit = async () => {
    if (env === "standalone") {
      dispatch(updateStandAloneVideoStatusFunction("reviewed", videoId));
      navigate("/coach_flow/reviewd-video");

      return null;
    }
    try {
      await changeVideoStatus();
      toast.success("Feedback submitted successfully!");
      navigate("/coach_flow/reviewd-video");
    } catch (error) {
      toast.error(error.message || "Error while submitting feedback");
    }
  };

  const changeVideoStatus = async () => {
    const formData = { state: "REVIEWED" };
    try {
      await changeVideoPostStatus(jwtToken, formData, videoId);
    } catch (error) {
      toast.error(
        error.message ||
        "An error occurred while updating the video status. Please try again."
      );
    }
  };

  const handlePauseVideo = () => {
    try {
      if (playerRef?.current && typeof playerRef.current.pause === 'function') {
        playerRef.current.pause();
        setIsPaused(true);
      } else if (videoRef?.current) {
        videoRef.current.pause();
        setIsPaused(true);

      } else { }
    } catch (error) { }

  };

  const handlePlayVideo = () => {
    // Pause any playing audio
    document.querySelectorAll('audio').forEach(audio => {
      audio.pause();
    });
    setPlayingAudioId(null);

    try {
      if (playerRef?.current && typeof playerRef.current.play === 'function') {

        playerRef.current.play().catch((error) => { });
        setIsPaused(false);
      } else { }
    } catch (error) { }

  };

  const handleVideoEnd = () => {
    setIsPaused(false); // Set paused to false when the video ends
  };

  const handleUpdateComment = async (annotation) => {
    try {
      if (!editedCommentText.trim()) {
        toast.error("Comment cannot be empty");
        return;
      }

      // Create updated annotation with new comment
      const updatedAnnotation = {
        ...annotation,
        comments: [
          {
            _id: uuidv4(), // Generate unique ID for each comment
            ...annotation.comments[0],
            body: editedCommentText.trim(),
            metaData: {
              ...annotation.comments[0].metaData,
              dateTime: new Date().toISOString(),
            },
          },
        ],
      };

      // Update annotations array
      const updatedAnnotations = annotations.map((a) =>
        a._id === annotation._id ? updatedAnnotation : a
      );

      // Update local state
      setAnnotations(updatedAnnotations);
      setOnceTimeAnnotaions(updatedAnnotations);

      // Save to backend
      await saveFeedback(updatedAnnotations);

      // Reset edit state
      setEditingCommentId(null);
      setEditedCommentText("");

      toast.success("Comment updated successfully");
    } catch (error) {
      toast.error("Failed to update comment. Please try again.");
    }
  };

  const handleDeleteClick = (annotation) => {
    if (playerRef.current) {
      playerRef.current.pause();
    }
    setAnnotationToDelete(annotation);
    setDeleteDialogOpen(true);
  };

  const handleDeleteCancel = () => {
    if (playerRef.current) {
      playerRef.current.play();
    }
    setDeleteDialogOpen(false);
    setAnnotationToDelete(null);
  };

  const handleDeleteConfirm = async () => {
    if (!annotationToDelete) return;
    if (playerRef.current) {
      playerRef.current.play();
    }
    setDeleteDialogOpen(false);
    setIsDeleting(true);

    try {
      // Filter out the annotation with the matching ID
      const updatedAnnotations = annotations.filter(
        (a) => a._id !== annotationToDelete._id
      );

      // Update local state
      setAnnotations(updatedAnnotations);
      setOnceTimeAnnotaions(updatedAnnotations);

      // Update markers with null checks
      try {
        if (playerRef?.current && playerRef.current.markers) {
          // First destroy existing markers
          if (typeof playerRef.current.markers.destroy === 'function') {
            playerRef.current.markers.destroy();
          }

          // Reinitialize markers plugin
          if (typeof playerRef.current.markers === 'function') {
            playerRef.current.markers({
              markerTip: {
                display: true,
                text: (marker) => marker.text,
              },
              markerStyle: {
                width: "5px",
                height: "20px",
                backgroundColor: "red",
                cursor: "pointer",
                borderRadius: "1px",
                bottom: "-8px",
              },
              markers: [], // Initialize with empty array
            });
          }

          // Only add markers if there are annotations
          if (updatedAnnotations.length > 0) {
            const markers = updatedAnnotations.map((annotation) => ({
              time: annotation.timeRange.startTime,
              text: annotation?.comments?.[0]?.body.startsWith("data:audio")
                ? "Audio"
                : annotation?.comments?.[0]?.body || "Annotation", // Default text if no comment exists
            }));

            // Add new markers
            if (typeof playerRef.current.markers.add === 'function') {
              playerRef.current.markers.add(markers);
            }
          }
        }

      } catch (error) { }


      // Save to backend
      await saveFeedback(updatedAnnotations);

      toast.success("Comment deleted successfully");
    } catch (error) {
      toast.error("Failed to delete comment. Please try again.");
    } finally {
      setIsDeleting(false);
      setAnnotationToDelete(null);
    }
  };

  const handleStartRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          setMediaStream(stream); // Store the stream
          const recorder = new MediaRecorder(stream);
          setMediaRecorder(recorder);
          const chunks = [];

          recorder.ondataavailable = (event) => {
            chunks.push(event.data);
          };

          recorder.onstop = async () => {
            stopMediaTracks(); // Stop media tracks after recording
            // Only process the audio if recording wasn't stopped due to timeout
            if (!recorder.exceededMaxDuration) {
              setAudioChunks(chunks);
              const audioBlob = new Blob(chunks, { type: "audio/wav" });
              const base64MP3 = await convertWavToMp3(audioBlob);
              setAudioComment(base64MP3);
            }
          };

          recorder.start();
          setIsRecording(true);

          // Stop recording after maxRecordingDuration seconds
          setTimeout(() => {
            if (recorder.state === "recording") {
              recorder.exceededMaxDuration = true; // Mark that we stopped due to timeout
              recorder.stop();
              setIsRecording(false);
              setAudioComment(null);
              setAudioChunks([]);
              toast.error(
                `Please record the audio again under the duration of ${maxRecordingDuration} seconds.`
              );
            }
          }, (maxRecordingDuration + 1) * 1000);
        })
        .catch((error) => {
          toast.error("Error accessing microphone.");
        });
    } else {
      toast.error("Audio recording is not supported in this browser.");
    }
  };

  const stopMediaTracks = () => {
    if (mediaStream) {
      mediaStream.getTracks().forEach(track => {
        track.stop();
      });
      setMediaStream(null);
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();
      setIsRecording(false);
      stopMediaTracks(); // Stop media tracks after recording
    }
  };

  const convertWavToMp3 = async (audioBlob) => {
    if (!ffmpeg.loaded) {
      await ffmpeg.load();
    }

    // Convert Blob to ArrayBuffer
    const fileData = await audioBlob.arrayBuffer();

    // Write WAV file to FFmpeg's virtual filesystem
    await ffmpeg.writeFile("input.wav", new Uint8Array(fileData));

    // Convert WAV to MP3 (64kbps)
    await ffmpeg.exec(["-i", "input.wav", "-b:a", "64k", "output.mp3"]);

    // Read the MP3 file from FFmpeg's filesystem
    const mp3Data = await ffmpeg.readFile("output.mp3");

    // Convert MP3 file to a Blob
    const mp3Blob = new Blob([mp3Data], { type: "audio/mp3" });

    // Convert Blob to Base64
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(mp3Blob);
      reader.onloadend = () => resolve(reader.result);
    });
  };

  const handleDeleteAudio = () => {
    setAudioComment(null);
    setAudioChunks([]);
  };

  const handleAudioPlay = (audioElement, annotation) => {
    // Pause video if playing
    if (playerRef.current) {
      playerRef.current.pause();
    }

    // Pause any other playing audio
    document.querySelectorAll('audio').forEach(audio => {
      if (audio !== audioElement) {
        audio.pause();
      }
    });

    setPlayingAudioId(annotation._id);

    // Add ended event listener to reset playingAudioId
    audioElement.addEventListener('ended', () => {
      setPlayingAudioId(null);
    });
  };



  const downloadPDF = async (reportType = "summary") => {
    setIsDownloading(true);

    try {
      const response = await fetch(
        `${GET_INDIVIDUAL_REPORT}/${postId}/reports`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify(
            reportType === "detailed"
              ? { type: "detailed report" }
              : { type: "summary" }
          ),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("Success:", responseData);

      const url =
        responseData?.data?.data?.url ||
        responseData?.data?.url ||
        responseData?.url;

      if (url) {
        // This will open the URL in a new tab without getting blocked
        window.open(url, "_blank");
        toast.success("Report opened in a new tab!");
      } else {
        toast.error("Report URL not found.");
      }

    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download report.");
    } finally {
      setIsDownloading(false);
    }
  };


  const handleGenerateAiFeedbackClick = async () => {
    TagHelper.debugTagStructure(videoTagList);

    let extractedVideoTags = TagHelper.extractTagNamesFromObjects(videoTagList);

    if (!(url?.length > 0 && extractedVideoTags.length > 0
      && videoId.length > 0)) {
      toast.error("Missing required data: URL, video tags, or video ID");
      return;
    }

    if (isRallyDataNotFound && videoTagList.some(tag => tag?.tagName === "Match Video")) {
      setShowNoInsightsModal(true);
      return;
    }

    try {
      if (aiFeedbackState === AI_FEEDBACK_CREATED) {
        setIsGeneratingFeedback(true);
        const startTime = Date.now();
        generationStartTimeRef.current = startTime;
        localStorage.setItem(`generationStartTime_${videoId}`, startTime.toString());
        localStorage.setItem(`latestAiFeedbackState_${videoId}`, AI_FEEDBACK_REVIEW_REQUESTED);
        setAiFeedbackState(AI_FEEDBACK_REVIEW_REQUESTED);

        // Reset the fetched flag when starting new AI feedback generation
        aiFeedbackFetchedRef.current = false;

        const aiFeedbackParams = {
          videoUrl: url,
          videoTags: extractedVideoTags,
        };

        const stringifiedAiFeedbackParams = JSON.stringify(aiFeedbackParams);
        const apiUrl = GENERATE_AI_FEEDBACKS.replace('{postId}', videoId);

        if (stringifiedAiFeedbackParams.length === 0) {
          throw new Error("Stringification error");
        }

        const res = await axios.post(apiUrl, stringifiedAiFeedbackParams, {
          headers: {
            "Authorization": `Bearer ${jwtToken} `,
            'Content-Type': 'application/json'
          }
        });

        if (res?.data?.code === 200) {
          // Check if this is a match video with existing rally data
          if (res?.data?.message === 'match video already has rally data, skipping ai feedback generation' && res?.data?.data?.matchRallyId) {
            // Match video — rally data already exists, show publish modal
            setIsGeneratingFeedback(false);
            setAiFeedbackState(AI_FEEDBACK_CREATED);
            setMatchRallyId(res.data.data.matchRallyId);
            setMatchVideoReadyToPublish(true);
            setShowMatchVideoModal(true);
          } else {
            setAiFeedbackState(AI_FEEDBACK_REVIEW_REQUESTED);
            toast.success("AI feedback generation started!");
          }
        }
        else {
          toast.error("Unable to call AI for feedbacks");
          setIsGeneratingFeedback(false);
          setAiFeedbackState(AI_FEEDBACK_CREATED);
          throw new Error(res.data.message);
        }
      } else if (aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED || isGeneratingFeedback) {
        setShowNoInsightsModal(true);
      } else {
        // Fallback for completion or unknown states
        if (aiFeedbackState === AI_FEEDBACK_REVIEWED) {
          toast.info("AI feedback has already been generated");
        } else {
          setShowNoInsightsModal(true);
        }
      }
    }
    catch (error) {
      setIsGeneratingFeedback(false);
      setAiFeedbackState(AI_FEEDBACK_CREATED);
      toast.error("Unable to call AI: " + (error.message || error));
    }
  };

  const getAiFeedbackState = async () => {

    if (!(GET_AI_FEEDBACK_STATE?.length > 0 && videoId.length > 0))
      throw new Error("wrong data passed to GET_AI_FEEDBACK_STATE");

    const getAiFeedbackStateUrl = GET_AI_FEEDBACK_STATE.replace("{postId}", videoId);

    return axios.get(getAiFeedbackStateUrl, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwtToken} `,
      },
    }).then((response) => {
      setAiFeedbackState(response?.data?.data?.aiFeedbackState);
      return response?.data?.data?.aiFeedbackState;
    }

    ).catch((error) => {
      throw error;
    });
  };

  // Function to load existing AI feedback data for a video with retry logic
  const loadExistingAiFeedbackData = async (retryCount = 0, targetVideoId = null) => {
    const maxRetries = 3;

    // Use provided targetVideoId or current videoId
    const videoIdToLoad = targetVideoId || videoId;

    if (!jwtToken || !videoIdToLoad) {
      return false;
    }

    // Allow loading data for different video (for navigation scenarios)
    // Only warn if it's a significant mismatch
    if (videoIdToLoad !== videoId) { }

    try {
      const response = await fetchCachedFeedback(jwtToken, videoIdToLoad);

      if (response && response?.code === 200 &&
        response?.data?.aiFeedbackState &&
        response?.data?.feedbacks) {
        // Check if response is for the current video (allow for navigation scenarios)
        if (response.data.videoId && response.data.videoId !== videoIdToLoad) { }

        // Update annotations with existing AI feedback
        setAnnotations(response.data.feedbacks);
        setAiFeedbackState(response.data.aiFeedbackState);

        // Mark as fetched to prevent duplicate calls
        aiFeedbackFetchedRef.current = true;

        return true;
      } else {
        // Clear any old annotations that might be from previous video
        if (annotations.length > 0) {
          setAnnotations([]);
        }

        // Retry if we haven't exceeded max retries
        if (retryCount < maxRetries) {
          setTimeout(() => {
            loadExistingAiFeedbackData(retryCount + 1, videoIdToLoad);
          }, 1000 * (retryCount + 1)); // Exponential backoff
          return false;
        } else {
          return false;
        }
      }
    } catch (error) {
      // Retry on error if we haven't exceeded max retries
      if (retryCount < maxRetries) {
        setTimeout(() => {
          loadExistingAiFeedbackData(retryCount + 1, videoIdToLoad);
        }, 1000 * (retryCount + 1)); // Exponential backoff
        return false;
      } else {
        return false;
      }
    }
  };

  const startPollingAiFeedbackState = async () => {
    // Prevent duplicate polling
    if (isPollingActiveRef.current) {
      return;
    }

    isPollingActiveRef.current = true;

    intervalRef.current = setInterval(async () => {
      try {
        const latestAiFeedbackState = await getAiFeedbackState();

        // Optimistic check: If we just started generating (locally or recorded in localStorage),
        // ignore a stale 'created' state from the server for the first 45 seconds.
        const timeSinceStart = Date.now() - generationStartTimeRef.current;
        if (latestAiFeedbackState === AI_FEEDBACK_CREATED && timeSinceStart < 45000) {
          return;
        }

        localStorage.setItem(`latestAiFeedbackState_${postId}`, latestAiFeedbackState);
        setAiFeedbackState(latestAiFeedbackState);

        if (latestAiFeedbackState === AI_FEEDBACK_REVIEWED) {
          clearInterval(intervalRef.current);
          setIsGeneratingFeedback(false);
          setIsPaused(false);
          setDrawing(false);
          isPollingActiveRef.current = false; // Reset polling flag

          // Check if we already have AI feedback data or already fetched it
          const hasAiFeedbackData = annotations && annotations.length > 0 &&
            annotations.some(annotation => annotation.type === 'ai_feedback' || annotation.isAI);

          if (hasAiFeedbackData || aiFeedbackFetchedRef.current) {
            return; // Skip API call if we already have data or fetched it
          }

          try {
            const response = await fetchCachedFeedback(jwtToken, videoId);

            if (response && response?.code === 200 &&
              response?.data?.aiFeedbackState &&
              response?.data?.feedbacks) {
              setAnnotations(response.data.feedbacks);
              setAiFeedbackState(response.data.aiFeedbackState);

              // Mark as fetched to prevent future calls
              aiFeedbackFetchedRef.current = true;

              // Force re-render by updating video key
              setVideoKey(Date.now());
            } else { }
          } catch (fetchError) { }
        }
      }
      catch (ex) {
        clearInterval(intervalRef.current);
        isPollingActiveRef.current = false; // Reset polling flag on error
      }
    }, POLLING_INTERVAL_IN_SECS);

    setTimerInterval(intervalRef.current);
  };

  const fullVideoCount = localStorage.getItem("fullVideoCount");

  // Debug log for current state
  const currentVideos = env === "standalone"
    ? videoData.filter(video => video.state === "review_requested")
    : videoData;


  // Additional debug logging for position validation
  useEffect(() => {
    const testCases = [
      [1, 0, 1],   // Page 1, first video (index 0) = Global position 1
      [1, 4, 5],   // Page 1, 5th video (index 4) = Global position 5
      [1, 8, 9],   // Page 1, last video (index 8) = Global position 9
      [2, 0, 10],  // Page 2, first video (index 0) = Global position 10
      [2, 4, 14],  // Page 2, 5th video (index 4) = Global position 14
      [2, 8, 18],  // Page 2, last video (index 8) = Global position 18
      [3, 0, 19],  // Page 3, first video (index 0) = Global position 19
      [3, 4, 23],  // Page 3, 5th video (index 4) = Global position 23
    ];

    testCases.forEach(([page, indexInPage, expectedGlobalPosition]) => {
      const skip = page - 1; // Use skip = page - 1 formula
      const calculatedGlobalPosition = (skip * VIDEO_SEARCH_API_LIMIT) + indexInPage + 1;
      const isCorrect = calculatedGlobalPosition === expectedGlobalPosition;
    });
  }, [videoId, currentPage, currentVideoIndex, totalRecords, actualTotalCount]);


  // Function to handle video click from Pending.js - Redux only
  const handleVideoClickFromPending = useCallback((clickedVideo, pageContext) => {
    // Find the video in current Redux data and set the correct page
    if (pageContext && pageContext.currentPage) {
      goToPage(pageContext.currentPage);

      // Find video index in the page
      const videoIndex = pageContext.currentIndex || 0;
      setCurrentVideoIndex(videoIndex);

      // Set the video data directly - no localStorage needed
      setData(clickedVideo);
    }
  }, [goToPage]);

  // Expose the function globally for Pending.js to use
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.handleVideoClickFromPending = handleVideoClickFromPending;
    }
  }, [handleVideoClickFromPending]);

  // Load video data if not available in Redux
  useEffect(() => {
    if (!videoData || videoData.length === 0) {
      // Load the current page data
      const loadVideoData = async () => {
        if (!jwtToken || !userId || env === "standalone") return;

        try {
          const apiUrl = new URL(POST_LIST_POST);
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${jwtToken} `,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "condition": {
                "state": ["review_requested"],
                "searchTerm": "",
                "poster": userId
              },
              "sort": { "updatedAt": -1 },
              "skip": currentPage - 1,
              "limit": VIDEO_SEARCH_API_LIMIT
            })
          });

          if (response.ok) {
            const data = await response.json();
            if (data.code === 200 && data.data && data.data.searchResults) {
              const videos = data.data.searchResults;
              dispatch(updateVideoList({ videos }));
            }
          }
        } catch (error) { }
      };

      loadVideoData();
    }
  }, [videoData, jwtToken, userId, env, currentPage, dispatch]);

  // Initialize navigation state when videoData changes
  useEffect(() => {
    if (videoData && videoData.length > 0) {
      initializeNavigationState();
    } else { }
  }, [videoData, initializeNavigationState]);

  // AI Feedback state management using localStorage
  useEffect(() => {
    localStorage.setItem(`latestAiFeedbackState_${postId}`, aiFeedbackState);

    if (aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED) {
      try {
        startPollingAiFeedbackState();
      }
      catch (pollingError) { }
    }

    // Cleanup function to stop polling when component unmounts or aiFeedbackState changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        isPollingActiveRef.current = false;
      }
    };
  }, [aiFeedbackState]);

  // Debug URL and video data on component mount
  useEffect(() => {
    // If URL is still null, try to get it from reviewPost
    if (!url && reviewPost?.game?.[0]?.path) {
      localStorage.setItem("videoLinkInObjectStore", reviewPost.game[0].path);
    }
  }, [url, videoId, postId, reviewPost]);

  // Initialize global position when component loads
  useEffect(() => {
    if (currentPage && currentVideoIndex >= 0) {
      const initialPosition = ((currentPage - 1) * VIDEO_SEARCH_API_LIMIT) + currentVideoIndex + 1;
      setCurrentGlobalPosition(initialPosition);
    }
  }, [currentPage, currentVideoIndex]);

  // Restore position after page reload
  useEffect(() => {
    const restorePositionAfterReload = () => {
      const pendingReloadData = localStorage.getItem("pendingReloadPosition");

      if (pendingReloadData) {
        try {
          const reloadData = JSON.parse(pendingReloadData);
          const { position, page, videoIndex, videoId: storedVideoId, timestamp } = reloadData;

          // Check if this is a recent reload (within last 30 seconds)
          const isRecentReload = (Date.now() - timestamp) < 30000;

          if (isRecentReload && storedVideoId === videoId) {
            // Set the page and video index
            if (page && page !== currentPage) {
              goToPage(page);
            }

            if (videoIndex !== undefined && videoIndex !== currentVideoIndex) {
              setCurrentVideoIndex(videoIndex);
            }

            // Set global position
            if (position) {
              setCurrentGlobalPosition(position);
            }

            // Clear the stored data
            localStorage.removeItem("pendingReloadPosition");
          } else {
            localStorage.removeItem("pendingReloadPosition");
          }
        } catch (error) {
          localStorage.removeItem("pendingReloadPosition");
        }
      }
    };

    // Only run this effect once when component mounts
    restorePositionAfterReload();
  }, []); // Empty dependency array - only run once on mount

  // Add useEffect to monitor annotation changes
  useEffect(() => { }, [annotations, videoId]);

  // Reset AI feedback fetched flag when video changes
  useEffect(() => {
    aiFeedbackFetchedRef.current = false;
  }, [videoId]);

  // Clear annotations immediately when video changes
  useEffect(() => {
    if (videoId) {
      setAnnotations([]);
      setComment("");
      setAudioComment(null);
      setNewAnnotation(null);
      setCurrentTime(0);
      setDrawing(false);
      setIsPaused(false);

      // Update URL state for the new video
      const newVideoData = videoData?.find(video => video._id === videoId);
      if (newVideoData?.game?.[0]?.path) {
        localStorage.setItem("videoLinkInObjectStore", newVideoData.game[0].path);
      }
    }
  }, [videoId, videoData]);

  // Update AI feedback state when video changes (only for initial load, not navigation)
  useEffect(() => {
    if (!videoId) {
      return;
    }

    // Only run this effect for initial page load, not for navigation
    // Navigation is handled by navigateToSpecificVideo function
    const isInitialLoad = !data || data._id !== videoId;

    if (!isInitialLoad) {
      return;
    }

    // Clear any existing annotations from previous video immediately
    if (annotations.length > 0) {
      setAnnotations([]);
    }

    // Reset AI feedback fetched flag for new video
    aiFeedbackFetchedRef.current = false;

    // Get AI feedback state for the new video with fallback logic
    let newVideoAiFeedbackState = localStorage.getItem(`latestAiFeedbackState_${videoId}`);

    if (!newVideoAiFeedbackState) {
      newVideoAiFeedbackState = localStorage.getItem(`latestAiFeedbackState_${postId}`);
    }

    if (!newVideoAiFeedbackState) {
      // Try to get from video data if available
      const currentVideoData = videoData?.find(video => video._id === videoId);
      if (currentVideoData?.aiFeedbackState) {
        newVideoAiFeedbackState = currentVideoData.aiFeedbackState;
      } else {
        newVideoAiFeedbackState = "created"; // Default fallback
      }
    }

    // Update the AI feedback state for the new video
    setAiFeedbackState(newVideoAiFeedbackState);

    // Reset generating feedback state for new video
    setIsGeneratingFeedback(newVideoAiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED);

    // Load existing AI feedback data for the new video if it has been reviewed
    if (newVideoAiFeedbackState === AI_FEEDBACK_REVIEWED) {
      // Add a small delay to ensure component is ready
      setTimeout(() => {
        loadExistingAiFeedbackData(0, videoId); // Explicitly pass current videoId
      }, 200);
    }
  }, [videoId, postId, videoData, data]);

  return (
    <>
      <section className="mb-8 pt-24 font-sans">

        {displayDialogBoxForNewAIFeedbacks &&
          (<FetchLatestAiFeedbackPopUp getCachedFeedbacks={getCachedFeedbacks} handlePopUpClose={handlePopUpClose} />)}

        <div className="flex flex-col gap-0.5 mb-6 px-1">
          {/* Breadcrumbs */}
          <div className="flex items-center gap-2 text-xs text-gray-500 font-medium mb-1">
            <FontAwesomeIcon icon={faVideo} className="text-gray-400" />
            <span className="hover:text-emerald-600 transition-colors cursor-pointer" onClick={() => navigate(-1)}>Video Queue</span>
            <FontAwesomeIcon icon={faChevronRight} className="text-[10px] text-gray-300" />
            <span className="text-gray-900 font-bold">Creating Feedback</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight leading-tight">
            {videoTitle || "Unknown Title"}
          </h1>

          {/* Date */}
          <p className="text-gray-400 font-medium text-xs mt-1">
            {data?.updatedAt ? dataFormatter(data.updatedAt) : ""}
          </p>
        </div>
        <div className="flex flex-col lg:flex-row mt-4 min-h-[500px] lg:h-[calc(100vh-230px)] bg-white rounded-3xl overflow-hidden shadow-xl border border-gray-100">
          <div className="relative w-full lg:w-3/4 bg-black flex items-center justify-center group overflow-hidden">
            <div className="w-full h-full relative aspect-video lg:aspect-auto">


              {/* macOS-style Navigation Buttons */}
              {(actualTotalCount > 1 || videoData?.length > 1) && (
                <div className="absolute top-2 right-2 md:top-4 md:right-4 z-[30] animate-in fade-in slide-in-from-top-4 duration-300">
                  <div className="flex items-center gap-0.5 md:gap-1 bg-black/60 backdrop-blur-md p-1 md:p-1.5 rounded-full border border-white/10 shadow-2xl hover:bg-black/70 transition-all duration-300 group/nav">
                    <button
                      className={`
                      w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center text-white/90 transition-all duration-200
                      ${currentVideoIndex === 0 && currentPage === 1 || isVideoDataLoading
                          ? 'opacity-30 cursor-not-allowed'
                          : 'hover:bg-white/20 hover:scale-105 active:scale-95 cursor-pointer'}
                    `}
                      onClick={handlePreviousVideo}
                      disabled={currentVideoIndex === 0 && currentPage === 1 || isNavigating || isVideoDataLoading}
                      title="Previous Video"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} className="text-[10px] md:text-xs" />
                    </button>

                    <div className="flex items-center justify-center h-4 md:h-5 px-2 md:px-3 border-x border-white/10 mx-0.5 md:mx-1">
                      {isNavigating || isVideoDataLoading ? (
                        <div className="w-3 h-3 md:w-4 md:h-4 border-2 border-white/20 border-t-white rounded-full animate-spin" />
                      ) : (
                        <span className="text-[10px] md:text-xs font-medium font-mono text-white/90 tracking-wider">
                          {(() => {
                            const pos = calculateGlobalPosition();
                            return `${pos.totalInSearch > 0 ? pos.currentPosition : '—'} / ${pos.totalInSearch > 0 ? pos.totalInSearch : '—'}`;
                          })()}
                        </span>
                      )}
                    </div>

                    <button
                      className={`
                      w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center text-white/90 transition-all duration-200
                      ${currentVideoIndex === (videoData?.length - 1) && currentPage === totalPages || isVideoDataLoading
                          ? 'opacity-30 cursor-not-allowed'
                          : 'hover:bg-white/20 hover:scale-105 active:scale-95 cursor-pointer'}
                    `}
                      onClick={handleNextVideo}
                      disabled={currentVideoIndex === (videoData?.length - 1) && currentPage === totalPages || isNavigating || isVideoDataLoading}
                      title="Next Video"
                    >
                      <FontAwesomeIcon icon={faChevronRight} className="text-[10px] md:text-xs" />
                    </button>
                  </div>
                </div>
              )}


              <div className="absolute inset-0">
                <VideoPlayer
                  key={`${videoId} -${videoKey} `}
                  videoId={videoId}
                  currentTime={currentTime}
                  videoLoaded={videoLoaded}
                  videoContent={videoContent}
                  annotations={annotations}
                  setAnnotations={setAnnotations}
                  setDisplayDialogBoxForNewAIFeedbacks={setDisplayDialogBoxForNewAIFeedbacks}
                  setOnceTimeAnnotaions={setOnceTimeAnnotaions}
                  setLoading={setLoading}
                  setVideoLoaded={setVideoLoaded}
                  setVideoKey={setVideoKey}
                  setFrameRate={setFrameRate}
                  setCurrentTime={setCurrentTime || (() => { })}
                  setVideoDimensions={setVideoDimensions}
                  thumbnailUrl={thumbnailUrl}
                  playerRef={playerRef}
                  videoRef={videoRef}
                  setEditingCommentId={setEditingCommentId}
                  handlePauseVideo={handlePauseVideo}
                  handlePlayVideo={handlePlayVideo}
                  handleVideoEnd={handleVideoEnd}
                  standAloneFeedbacks={standAloneFeedbacks}
                  setEditedCommentText={setEditedCommentText}
                  frameRate={frameRate}
                  isPaused={isPaused}
                  addStandaloneFeedback={addStandaloneFeedback}
                  getCoachFeedback={getCoachFeedback}
                  videoKey={videoKey}
                  env={env}
                  showAnnotations={false}
                  fallbackVideoUrl={data?.game?.[0]?.path}
                />
                {videoRef && playerRef && (
                  <AnnotationStage
                    videoRef={videoRef}
                    annotations={annotations}
                    newAnnotation={newAnnotation}
                    setNewAnnotation={setNewAnnotation}
                    drawing={drawing}
                    setDrawing={setDrawing}
                    playerRef={playerRef}
                    isPaused={isPaused}
                    key={videoKey}
                    onContentRectChange={setContentRect}
                    videoDimensions={videoDimensions}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/4 flex flex-col bg-white border-l border-gray-200 relative shrink-0 h-[600px] lg:h-auto">
            <div className="absolute inset-0 bg-emerald-50/30 backdrop-blur-[2px] z-0 pointer-events-none" />

            {/* Main Container - Flex Column, No Scroll on Parent */}
            <div className="relative z-10 flex flex-col h-full overflow-hidden">

              {/* Fixed Top Section: Video Details + Inputs + Buttons */}
              <div className="flex-none p-3 border-b border-gray-200 bg-white/50 backdrop-blur-sm z-20 shadow-sm">

                {/* Video Details Header */}
                <div className="mb-2 flex items-center gap-2">
                  <h4 className="text-sm font-bold text-gray-800">Video Details</h4>
                </div>
                <GameVideoDetails videoTagList={videoTagList} />

                {/* Actions & Inputs */}
                <div className="flex flex-col gap-2 mt-3">
                  <button
                    disabled={isGetAiFeedbackButtonDisabled}
                    key={aiFeedbackState}
                    className={`
                     w-full py-2 px-4 rounded-xl font-bold text-xs shadow-md transition-all duration-300 flex items-center justify-center gap-2 mb-2
                     ${aiFeedbackState === AI_FEEDBACK_CREATED || aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED
                        ? 'bg-[#237e45] text-white hover:bg-[#1b6136] hover:shadow-lg hover:scale-[1.02] active:scale-95'
                        : 'bg-[#237e45]/50 text-white cursor-not-allowed shadow-inner'}
                  `}
                    onClick={handleGenerateAiFeedbackClick}
                    title={isGetAiFeedbackButtonDisabled ?
                      `Button disabled: ${!localStorage.getItem("exclusiveFeaturesEnabled")?.includes('Generate AI Feedback') ? 'Feature not enabled' : 'AI feedback already in progress'} ` :
                      'Generate AI Feedback'}
                  >
                    <FontAwesomeIcon icon={faBolt} className={isGeneratingFeedback ? "animate-pulse" : ""} />
                    {aiFeedbackState === AI_FEEDBACK_CREATED ?
                      GENERATE_AI_FEEDBACK_BUTTON_STATE[0] :
                      (aiFeedbackState === AI_FEEDBACK_REVIEW_REQUESTED ?
                        GENERATE_AI_FEEDBACK_BUTTON_STATE[1] :
                        GENERATE_AI_FEEDBACK_BUTTON_STATE[2]
                      )
                    }
                  </button>

                  {/* View in SmartInsights */}
                  {videoTagList.some(tag => tag?.tagName === "Match Video") && (
                    <button
                      type="button"
                      onClick={handleViewInSmartInsights}
                      disabled={loadingSmartInsights}
                      className={`
                    w-full py-2 px-4 rounded-xl font-bold text-xs shadow-md transition-all duration-300 flex items-center justify-center gap-2 mb-3
                    bg-white border border-emerald-200 text-emerald-700 hover:bg-emerald-50 hover:border-emerald-300 hover:shadow-lg hover:-translate-y-0.5
                    disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0
                  `}
                      title="Open this match in SmartInsights Playground"
                    >
                      {loadingSmartInsights ? (
                        <div className="w-4 h-4 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
                      ) : (
                        <FontAwesomeIcon icon={faBolt} />
                      )}
                      {loadingSmartInsights ? 'Loading...' : 'View in SmartInsights'}
                    </button>
                  )}

                  <h4 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2 flex items-center gap-2">
                    <span className="w-1 h-3 bg-emerald-500 rounded-full"></span>
                    Add Feedback
                  </h4>
                  <div className="relative mb-2 group">
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Type your feedback here..."
                      className="w-full min-h-[80px] p-3 pr-10 text-xs font-medium bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500 outline-none transition-all shadow-sm resize-y"
                    />
                    <button
                      className={`
                    absolute bottom-3 right-3 p-2 rounded-full transition-all duration-300
                    ${isRecording
                          ? 'bg-red-50 text-red-500 animate-pulse ring-2 ring-red-200'
                          : 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100 hover:scale-110'}
                  `}
                      onClick={
                        isRecording ? handleStopRecording : handleStartRecording
                      }
                      title={isRecording ? "Stop Recording" : "Record Audio"}
                    >
                      <FaMicrophone className={isRecording ? "animate-bounce" : ""} />
                    </button>
                  </div>
                  {audioComment && (
                    <div className="flex items-center gap-2 p-3 bg-emerald-50 rounded-lg border border-emerald-100 mb-3 animate-in fade-in slide-in-from-top-2">
                      <audio
                        controls
                        src={audioComment}
                        className="h-8 w-full accent-emerald-600"
                        onPlay={(e) => handleAudioPlay(e.target, { _id: 'preview' })}
                      />
                      <button
                        className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
                        onClick={handleDeleteAudio}
                      >
                        <FaTrashIcon size={14} />
                      </button>
                    </div>
                  )}
                  <button
                    className={`
                  w-full py-2 px-4 rounded-xl font-bold text-xs shadow-sm transition-all duration-200 flex items-center justify-center gap-2
                  ${!comment.trim() && !audioComment
                        ? 'bg-[#237e45]/50 text-white cursor-not-allowed'
                        : 'bg-[#237e45] text-white hover:bg-[#1b6136] hover:shadow-md active:scale-95'}
                `}
                    onClick={handleSaveAnnotation}
                    disabled={!comment.trim() && !audioComment} // Disable when no comment or audio
                  >
                    {isLoading ? (
                      <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    ) : (
                      "Save Feedback"
                    )}
                  </button>
                </div>
              </div>

              {/* Scrollable Bottom Section: Feedback List */}
              <div className="flex-1 overflow-y-auto custom-scrollbar px-3 pb-3 pt-0">
                <FeedbackList
                  annotations={annotations}
                  clearAllFeedbacks={clearAllFeedbacks}
                  videoContent={videoContent}
                  handleDeleteClick={handleDeleteClick}
                  handleAudioPlay={handleAudioPlay}
                  handleUpdateComment={handleUpdateComment}
                  editingCommentId={editingCommentId}
                  setEditingCommentId={setEditingCommentId}
                  editedCommentText={editedCommentText}
                  setEditedCommentText={setEditedCommentText}
                  handleDeleteConfirm={handleDeleteConfirm}
                  handleDeleteCancel={handleDeleteCancel}
                  handleDeleteAudio={handleDeleteAudio}
                  isDeleting={isDeleting}
                  isSaving={isSaving}
                  currentTime={currentTime}
                  showClearButton={true}
                />
              </div>
            </div>
          </div>
        </div>




        <CoachClosingFeedback
          key={videoId} // Force re-render when video changes
          coachManualFeedback={data?.coachManualFeedback}
          videoTagList={videoTagList}
          readOnly={false}
        />

        <div className="mt-8 flex items-center justify-end gap-3 pb-8 border-t border-gray-100 pt-6">
          <button
            className="px-6 py-2.5 rounded-xl text-gray-600 font-semibold hover:bg-gray-100 hover:text-gray-900 transition-colors flex items-center gap-2"
            onClick={backNavigation}
          >
            <FontAwesomeIcon icon={faXmark} />
            Cancel
          </button>

          <button
            disabled={isDownloading || videoContent.isStartedvideoContent}
            className={`
              px-6 py-2.5 rounded-xl font-semibold transition-all duration-200 flex items-center gap-2 border
              ${isDownloading
                ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:shadow-sm'}
            `}
            onClick={handleClick}
            title={isDownloading ? 'Downloading...' : 'Download report'}
          >
            {isDownloading ? (
              <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
            ) : (
              <FontAwesomeIcon icon={faDownload} />
            )}
            {isDownloading ? 'Downloading...' : 'Download Report'}
          </button>
          <Menu
            id="fade-menu-coach-create"
            MenuListProps={{
              'aria-labelledby': 'fade-button-coach-create',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            PaperProps={{
              sx: {
                borderRadius: '12px',
                marginTop: '8px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: '1px solid #f3f4f6',
                zIndex: 3005,
                '& .MuiMenuItem-root': {
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  padding: '10px 16px',
                  color: '#374151',
                  '&:hover': {
                    backgroundColor: '#f0fdf4',
                    color: '#059669',
                  },
                },
              },
            }}
          >
            <MenuItem onClick={() => handleDownload('summary')}>Summary Report</MenuItem>
            <MenuItem onClick={() => handleDownload('detailed')}>Detailed Report</MenuItem>
          </Menu>

          <Tooltip 
            title={(!isMatchVideo && aiFeedbackState !== AI_FEEDBACK_REVIEWED) ? "Please Generate the AI feedback to publish report" : ""}
            arrow
            placement="top"
          >
            <span className="flex">
              <button
                disabled={videoContent.isStartedvideoContent || (!isMatchVideo && aiFeedbackState !== AI_FEEDBACK_REVIEWED)}
                className={`
                  px-8 py-2.5 rounded-xl font-bold text-white shadow-md transition-all duration-300 flex items-center gap-2
                  ${(videoContent.isStartedvideoContent || (!isMatchVideo && aiFeedbackState !== AI_FEEDBACK_REVIEWED))
                    ? 'bg-[#237e45]/50 text-white cursor-not-allowed'
                    : 'bg-[#237e45] hover:bg-[#1b6136] hover:shadow-lg hover:scale-105 active:scale-95'}
                `}
                onClick={submitData}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
                Publish Report
              </button>
            </span>
          </Tooltip>
        </div>

      </section >

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        slotProps={{
          root: { sx: { zIndex: 3001 } },
          backdrop: { sx: { zIndex: 3000 } },
        }}
        PaperProps={{ sx: { zIndex: 3002 } }}
      >
        <DialogTitle id="alert-dialog-title">{"Delete Feedback"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this feedback? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} autoFocus color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Publish Without Feedback Confirmation Dialog */}
      <Dialog
        open={showPublishConfirmation}
        onClose={() => setShowPublishConfirmation(false)}
        aria-labelledby="publish-dialog-title"
        aria-describedby="publish-dialog-description"
        slotProps={{
          root: { sx: { zIndex: 9999 } },
          backdrop: { sx: { zIndex: 9998 } },
        }}
        PaperProps={{ sx: { zIndex: 10000 } }}
      >
        <DialogTitle id="publish-dialog-title">{"Publish Report"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="publish-dialog-description">
            Are you ok to submit without the coach feedback?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPublishConfirmation(false)}>No</Button>
          <Button onClick={handleConfirmPublish} autoFocus color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Match Video Rally Ready Modal (Analysis Complete) */}
      {showMatchVideoModal && (
        <div className="fixed inset-0 z-[4000] flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setShowMatchVideoModal(false)}>
          <div 
            className="relative w-full max-w-md mx-4 bg-white rounded-[24px] shadow-2xl overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            {/* Top Decoration */}
            <div style={{ backgroundColor: '#247E45' }} className="h-28 flex items-center justify-center relative">
               <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center border border-white/30">
                  <FontAwesomeIcon icon={faCheck} style={{ color: 'white' }} className="text-2xl" />
               </div>
            </div>

            <div className="p-6 text-center">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Analysis Complete!</h2>
              <p className="text-slate-600 text-sm leading-relaxed mb-8 px-2">
                AI feedback has been successfully processed for this match. You can now view detailed insights or publish the final report.
              </p>
              
              <div className="flex flex-row gap-3">
                <button
                  onClick={() => { setShowMatchVideoModal(false); handleViewInSmartInsights(); }}
                  className="flex-1 py-2.5 px-3 bg-slate-100 text-slate-700 rounded-xl font-bold text-xs tracking-wide hover:bg-slate-200 transition-colors border border-slate-200 whitespace-nowrap"
                >
                  View Insights
                </button>
                <button
                  onClick={() => { setShowMatchVideoModal(false); submitData(); }}
                  style={{ backgroundColor: '#247E45', color: 'white' }}
                  className="flex-1 py-2.5 px-3 rounded-xl font-bold text-xs tracking-wide shadow-md hover:opacity-90 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <FontAwesomeIcon icon={faPaperPlane} style={{ color: 'white' }} />
                  Publish Report
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* No SmartInsights Data Modal (Insights Pending) */}
      {showNoInsightsModal && (
        <div className="fixed inset-0 z-[4000] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={() => setShowNoInsightsModal(false)}>
          <div 
            className="w-full max-w-sm mx-4 bg-white rounded-2xl shadow-2xl p-8 text-center"
            onClick={e => e.stopPropagation()}
          >
            <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6 border border-amber-100">
              <FontAwesomeIcon icon={faBolt} className="text-amber-500 text-2xl" />
            </div>
            
            <h3 className="text-xl font-bold text-slate-900 mb-3">Insights Pending</h3>
            <p className="text-slate-600 text-sm leading-relaxed mb-8 px-4">
              AI feedbacks and deep analysis are currently being generated for this video. Please check back after sometime.
            </p>
            
            <button
              onClick={() => setShowNoInsightsModal(false)}
              style={{ backgroundColor: '#247E45', color: 'white' }}
              className="w-full py-2.5 rounded-xl font-bold text-xs tracking-wide hover:opacity-90 shadow-md transition-all whitespace-nowrap"
            >
              Understood
            </button>
          </div>
        </div>
      )}




      {/* Full Page Loader */}
      {
        (isDeleting || isSaving) && (
          <div className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm flex items-center justify-center">
            <div className="bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center gap-4">
              <div className="w-12 h-12 border-4 border-emerald-100 border-t-emerald-600 rounded-full animate-spin" />
              <p className="text-gray-600 font-medium animate-pulse">
                {isDeleting ? 'Deleting feedback...' : 'Saving changes...'}
              </p>
            </div>
          </div>
        )
      }

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
}
export default CreateFeedback;
